import Repository from './repository';
const resource = '/devs';

export default {
	find(payload) {
		return Repository.postWithAuth(
			`${resource}/find`,
			payload,
			{},
			{ noCache: true }
		);
	},
	getSwagger() {
		return Repository.getWithoutAuth('https://arritechlabs.github.io/docs/');
	},
	filters() {
		return Repository.getWithAuth(`${resource}/filters`);
	},
};
